// src/mocks/handlers/user/userProfileHandler.ts

import { rest } from 'msw';
import userProfile from '@/mocks/data/userProfile.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';

export const userProfileHandler = rest.get(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.USER_PROFILE}`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(userProfile));
  },
);
